let intervalId = setInterval(() => {
   // Obtener todos los elementos con la clase .aaa-add-gift-registry-grid
  const elements = document.querySelectorAll('.aaa-add-gift-registry-grid');
  if(document.querySelector('.gPreorderPoweredBy')){
    document.querySelector('.gPreorderPoweredBy').style.display = "none";
  }
  // Crear un Set para almacenar los elementos únicos (en base a su HTML o algún criterio único)
  const uniqueElements = new Set();

  elements.forEach(element => {
    // Usamos el HTML del elemento como criterio para comprobar duplicados
    const elementHTML = element.outerHTML;

    // Si el HTML ya está en el Set, es un duplicado, lo eliminamos
    if (uniqueElements.has(elementHTML)) {
      element.remove();
    } else {
      // Si no está en el Set, lo añadimos
      uniqueElements.add(elementHTML);
    }
  });
  let selectTypeCera = document.querySelector('#select-tipo-de-cera .select select');
  let selectTypeAroma = document.querySelector('#select-aroma');
  
  // Verificamos si el elemento selectTypeCera existe antes de proceder
  if (!selectTypeCera || !selectTypeAroma) {
    console.log('Los elementos no se encontraron en el DOM.');
    clearInterval(intervalId); // Detenemos el intervalo si los elementos no existen
    return; // Salimos de la función
  }

  // Lógica para mostrar u ocultar el campo de "Aroma" según el valor de "Tipo de Cera"
  if (selectTypeCera.value.includes('Polvo') || selectTypeCera.value.includes('polvo')) {
    selectTypeAroma.classList.add('hidden');
  } else {
    selectTypeAroma.classList.remove('hidden');
  }

  // Añadimos un listener para el cambio de selección
  selectTypeCera.addEventListener('change', (e) => {
    console.log('change');
    let selectValue = e.target.value; // Aquí corregimos el acceso al valor
    if (selectValue.includes('Polvo') || selectValue.includes('polvo')) {
      selectTypeAroma.classList.add('hidden');
    } else {
      selectTypeAroma.classList.remove('hidden');
    }
  });
}, 500); // Intervalo cada 500ms

